export default "__VITE_ASSET__CCjtaqB6__"